<template>
  <v-app>
    <v-row class="locale">
      <v-col>
        <switch-locale></switch-locale>
      </v-col>
    </v-row>
    <div class="login-header">
      <v-row>
        <v-col class="pt-5">
          <img src="@/assets/logo.svg" height="50" alt="logo" />
        </v-col>
      </v-row>
    </div>
    <div class="main">

        <v-alert dense text :type="type" dismissible v-model="alert">
              {{message}}
        </v-alert>
      <div class="login-form">
        <div class="welcome-text">
          <h3 style="margin-bottom: 0px">
              {{ $t("message.passwordResetPage.first", { value: "default" }) }}
          </h3>
        </div>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >

            <v-text-field
            v-model="pw"
            :rules="pwRules"
            :label="$t('message.login.pw', { value: 'default' })"
            required
            type="password"
            ></v-text-field>

            <v-text-field
            v-model="pwc"
            :rules="pwcRules"
            :label="$t('message.passwordResetPage.confirm', { value: 'default' })"
            required
            type="password"
            ></v-text-field>

            <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validate"
            >
            {{ $t("message.passwordResetPage.validate", { value: "default" }) }}
            </v-btn>
        </v-form>


      </div>
    </div>
  </v-app>
</template>

<script>
import SwitchLocale from "@/components/SwitchLocale";
import LoginService from "@/services/LoginService";

export default {
  name: "PasswordResetPage",

data: () => ({
      valid: true,
      alert:false,
      type:"",
      message: "",
      pw: '',
      pwRules: [
          value => !!value || 'password is required',
          (value) => (value && value.length >= 8) || 'minimum 8 characters',
          value => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(value) || 'Password must contain at least lowercase letter, one number, a special character and one uppercase letter'
      ],
      pwc: '',
    }),

    methods: {
      validate () {
        
        if (this.$refs.form.validate()) {
            let payload = {
                token: this.$route.params.token,
                password: this.pw    
            };
            LoginService.resetPassword(payload).then(()=>{
                this.message = "Mot de passe reinitialisé avec success"
                this.type = "success"
                this.alert = true
            }).catch(error => {
                this.message = error.response.data
                this.type = "error"
                this.alert = true
            })
        }
      }
    },

    computed: {
        pwcRules() {
            return [
                value => !!value || 'password confirmation is required',
                (value) => value === this.pw || 'The password confirmation does not match.'
            ];
        },
    },
  

  components: {
    SwitchLocale,
  },
};
</script>

<style scoped>
.login-header {
  margin: 0px auto;
  background-color: #fff;
  display: inline-flex;
}

.locale {
  position: absolute;
  right: 20px;
  top: 9px;
  width: 110px;
}

.main {
  background: url("../assets/background-login.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}

.login-form {
  margin: 150px auto;
  padding: 42px 79px 59px 79px;
  background: #fff;
  display: block;
  width: 565px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.welcome-text {
  text-align: center;
  font: normal normal normal 1em Calibri;
  color: #00475a;
  margin: 0px;
}

.pp > .theme--light.v-icon {
  color: #00475a;
}

p {
  padding: 0px;
  margin: 0px;
}

.v-btn {
  color: #fff;
}

a {
  color: #7b766a;
}
</style>